import { IsNotEmpty, IsOptional, IsString } from 'class-validator';
import type { ISubscriptionExtras } from './subscription.dto';

export interface ProductCategoryExtras {
  belugaMappedFields?: Record<string, any>;
  subscription?: ISubscriptionExtras;
  [key: string]: any;
}

export class IProductCategory {
  _id?: string;
  name: string;
  organization: string;
  description?: string;
  extras?: ProductCategoryExtras;
  createdAt: Date;
  updatedAt: Date;
}

export class GetProductCategoriesDto implements Partial<IProductCategory> {
  _id?: string;
  name?: string;
  organization?: string;
  description?: string;
  createdAt?: Date;
  updatedAt?: Date;
}

export class CreateProductCategoryDto {
  @IsNotEmpty()
  @IsString()
  name: string;

  @IsOptional()
  @IsString()
  description?: string;

  @IsOptional()
  @IsString()
  organization?: string;

  @IsOptional()
  extras?: ProductCategoryExtras;
}

export class UpdateProductCategoryDto {
  @IsOptional()
  @IsString()
  name?: string;

  @IsOptional()
  @IsString()
  description?: string;

  @IsOptional()
  extras?: ProductCategoryExtras;
}
